import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

import { Principal } from '../../shared';
import { Password } from './password.service';

@Component({
    selector: 'jhi-password',
    templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit {
    doNotMatch: string;
    error: string;
    success: string;
    account: any;
    password: string;
    confirmPassword: string;
    passwordChangeAllowed = true;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private passwordService: Password,
        private principal: Principal
    ) {
        this.jhiLanguageService.setLocations(['password']);
    }

    ngOnInit () {
        this.principal.identity().then((account) => {
            this.account = account;
            if (this.account.email.indexOf('@ens-lyon.fr') > 0) {
                this.passwordChangeAllowed = false;
            }
        });
    }

    changePassword () {
        if (this.password !== this.confirmPassword) {
            this.error = null;
            this.success = null;
            this.doNotMatch = 'ERROR';
        } else {
            this.doNotMatch = null;
            this.passwordService.save(this.password).subscribe(() => {
                this.error = null;
                this.success = 'OK';
            }, () => {
                this.success = null;
                this.error = 'ERROR';
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password/password.component.ts